<template>
  <div>
    <Head title="Users"/>
    <h1 class="mb-8 text-3xl font-bold">{{ $t('users.users') }}</h1>
    <Table
      :resource="data"
      class="custom-table-layout rounded"
      url-to-view="users"
      url-action="edit"
    >
      <template v-slot:extraButtons>
        <Link class="btn-indigo inline-flex items-center mr-2" href="/users/create" style="height: 38px">
          <icon name="plus" class="w-4 h-4 fill-current text-white mr-2"/>
          <span class="capitalize">{{ $t('users.new') }}</span>
        </Link>
      </template>
      <template #cell(authorization_date)="{ item: data }">
        {{ $filters.formatDate(data.authorization_date) }}
      </template>
      <template #cell(permissions)="{ item: user }">
        {{ user.permissions.join(', ') }}
      </template>
    </Table>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import Table from '@/Shared/Table/Components/Table'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  components: {
    Head,
    Icon,
    Link,
    SearchFilter,
    Table
  },
  layout: Layout,
  props: {
    data: Object,
  },
}
</script>
